import { render, staticRenderFns } from "./DirectChatTopBar.vue?vue&type=template&id=a0ed076a&"
import script from "./DirectChatTopBar.vue?vue&type=script&lang=js&"
export * from "./DirectChatTopBar.vue?vue&type=script&lang=js&"
import style0 from "./DirectChatTopBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports